import type { DebugLogLabelValue } from './types';

/**
 * Get the store from the current logger context.
 * Valus can be set directly on this map.
 */
export function getStoreFromLoggerContext(): Map<string, DebugLogLabelValue> | undefined {
    return new Map();
}

/**
 * Wrap an async execution in a new logger context.
 */
export function withLoggerContext<R>(
    callback: () => R,
    _defaultMap?: Map<string, DebugLogLabelValue>
): R {
    return callback();
}
